import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { getWindowHeight } from '#helper';

export const OverviewCtn = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  paddingTop: theme.spacing(3),
  height: 'calc(100% - 64px)',
  textAlign: 'left',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    paddingBottom: 0
  },
  [theme.breakpoints.down('sm')]: {
    '& > div:first-of-type': {
      padding: '0 32px'
    }
  },
  '& .leftSidebar': {
    height: '100%'
  },
  '& .leftSidebar > div.events': {
    [theme.breakpoints.up('md')]: {
      height: 552,
      overflowY: 'auto',
      '&::-webkit-scrollbar-track': {
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        borderRadius: 10,
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar': {
        width: 8,
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 10,
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
        backgroundColor: '#a0a0a0'
      }
    }
  },
  '&.scrolled .leftSidebar > div.events': {
    [theme.breakpoints.up('md')]: {
      width: 225,
      position: 'fixed',
      top: 10,
      height: getWindowHeight() - 20
    }
  },
  '@media screen and (max-height: 500px)': {
    height: 'auto'
  }
}));

export const MeasurementsWrapper = styled(Grid)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    maxWidth: '72%',
    flexBasis: '72%'
  },
  '@media screen and (max-height: 500px)': {
    paddingBottom: `${theme.spacing(3)} !important`
  }
}));

export const ShipmentLabelCnt = styled(Typography)({
  display: 'block',
  marginLeft: 6,
  lineHeight: '1.3em'
});

export const ShipmentLabelTooltip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    fontSize: 'unset'
  }
});

export const ShipmentLabel = styled('span')({
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

export const ShipmentProjectLabel = styled('div')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

export const SettingsCnt = styled('div')({
  display: 'flex',
  height: '100%',
  justifyContent: 'space-between'
});

export const DeviceNameCnt = styled('div')({
  display: 'flex',
  alignItems: 'center'
});

export const ShipmentUID = styled(Typography)(({ theme }) => ({
  margin: '1px 0 0 5px',
  verticalAlign: 'middle',
  '&.off': {
    color: '#667'
  },
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  cursor: 'pointer',
  lineHeight: '1em',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 0
  }
}));

export const TabCnt = styled('div')({
  position: 'relative'
});

export const TabBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: '#FFF',
  borderTopLeftRadius: theme.spacing(),
  borderTopRightRadius: theme.spacing()
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  minWidth: 72,
  display: 'flex',
  flexDirection: 'row',
  '& svg + span': {
    marginLeft: theme.spacing(),
    height: 13
  },
  '&.colorRed': {
    color: '#FF4635 !important'
  }
}));

export const Divider = styled('div')({
  marginTop: -1
});
